export default function(x: never) {}
